import type { RebalanceInsightAiContext } from '../../types/insightNarrative.types';

const isEmptyValue = (value: unknown): boolean => {
  if (value == null) {
    return true;
  }

  if (typeof value === 'string' && value.trim() === '') {
    return true;
  }

  if (Array.isArray(value) && value.length === 0) {
    return true;
  }

  return false;
};

export const compactInsightAiContext = (
  context: RebalanceInsightAiContext,
): RebalanceInsightAiContext => {
  const compacted = Object.fromEntries(
    Object.entries(context).filter(([, value]) => !isEmptyValue(value)),
  ) as RebalanceInsightAiContext;

  return {
    ...compacted,
    scope: context.scope,
  };
};

export const takeFirst = <T>(values: T[] | undefined, limit: number): T[] =>
  (values ?? []).slice(0, limit);
